export { DetailsGear } from './DetailsGear';
